import React, { useEffect, useState } from 'react';
import { OrderContractApi } from '../../apis/OrderContractApi';
import { Order } from '../../models/OrderContract';
import { BaseCardContent } from '../MessageType';
import { CachedImage } from '../../components/CachedImage';
import { AppDetailClickable } from './AppDetailTip';

interface OrderCardViewProps {
  content: BaseCardContent;
  isSelf: boolean;
}

export const OrderCardView: React.FC<OrderCardViewProps> = ({ content }) => {
  const orderId = content.orderId as string;
  const [order, setOrder] = useState<Order | null>(null);

  useEffect(() => {
    if (!orderId) {
      return;
    }
    OrderContractApi.getOrderDetail(orderId).then(setOrder);
  }, [orderId]);

  const snapshot = order?.productSnapshot;
  const title = snapshot?.name || '订单';
  const imageUrl = snapshot?.headImageUrl || '';

  return (
    <AppDetailClickable>
      <div className="message-card message-order-card">
        <div className="message-card-title">订单</div>
        <div className="message-product-body">
          {imageUrl ? (
            <CachedImage
              url={imageUrl}
              enablePreview={false}
              style={{ width: 72, height: 72, borderRadius: 4 }}
            />
          ) : (
            <div className="message-product-thumb-placeholder" />
          )}
          <div className="message-product-info">
            <div className="message-product-desc">{title}</div>
            {order && <div className="message-order-price">¥{order.price}</div>}
          </div>
        </div>
        <div className="message-order-hint">点击前往 APP 查看详情</div>
      </div>
    </AppDetailClickable>
  );
};
